import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { ToastrService } from 'src/app/_services/toastr.service';
import { NavService } from 'src/app/_services/nav.service';
import { TranslateService } from '@ngx-translate/core';

import { PopupEditUserComponent } from '../administracion/compañia-detail/edit-user-popup.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/models/company.model';
import { CompanyService } from 'src/app/_services/company.service';
import { DatePeriodService } from 'src/app/_services/date-period.service';
import { SyncService } from 'src/app/_services/sync.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { environment } from 'src/environments/environment';
import { CacheService } from 'src/app/_services/cache.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'nav[app-header]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentUserPhoto: string;
  currentUserName: string;
  subscription: Subscription;
  private subscriptions: Subscription[] = [];
  data: any;
  currentLanguageImage: string;
  currentEmail: string;

  showDatePeriod: boolean = false;

  minDate: any;
  maxDate: any;
  rangeDate: any;
  maxDateInput: Date = new Date();

  companies: Company[] = [];

  currentUser: any;

  languageList = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Spanish' },
  ];

  protected ngbModalRef: NgbModalRef;

  maxLength: number = 25;

  isMenuOpen: boolean;

  userFullName: string;
  lastSync: string;

  isAdmin;
  showSelectCompanyDropdown = false;
  selectedCompany;
  accountCompanies;
  isLoadingCompanies;
  userCompany;
  canSelectCompany = true;
  @ViewChild(NgSelectComponent) ngSelect: NgSelectComponent;

  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastrService: ToastrService,
    private navService: NavService,
    public translate: TranslateService,
    private modalService: NgbModal,
    public companyService: CompanyService,
    private dataPeriodService: DatePeriodService,
    public syncService: SyncService,
    public cacheService: CacheService
  ) {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkCurrentRoute();
      }
    });
    this.subscriptions.push(routerSubscription);

    this.minDate = new Date().getDate() - 7;

    const adminSubscription = this.authService.isAdmin().subscribe((res) => {
      this.isAdmin = !!res;
    });
    this.subscriptions.push(adminSubscription);
  }

  private checkCurrentRoute(): void {
    const currentRoute = this.router.url;

    this.showDatePeriod = currentRoute === '/home/index';
  }

  ngOnInit() {
    const accountSubscription = this.authService
      .getAccount(window.localStorage.getItem('id'))
      .subscribe((res) => {
        this.userFullName = res?.userlist?.name;
        localStorage.setItem('username', res?.userlist?.name);
      });
    this.subscriptions.push(accountSubscription);

    this.isLoadingCompanies = true;
    const companiesSubscription = this.companyService
      .getOnlyAllCompanies(1, 0)
      .subscribe((companies: any) => {
        if (companies.body.results) {
          this.accountCompanies = companies.body.results.map((company) => {
            return {
              value: company.id,
              label: company.name,
            };
          });

          this.accountCompanies = this.accountCompanies.sort((a, b) => {
            if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
            if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
            return 0;
          });

          if (this.accountCompanies.length > 1) {
            this.canSelectCompany = true;
          } else {
            this.canSelectCompany = false;
          }
        }
        this.isLoadingCompanies = false;
        setTimeout(() => {
          this.ngSelect?.open();
        }, 100);
      });
    this.subscriptions.push(companiesSubscription);

    this.setCurrentLanguageImage();
    this.subscription = this.navService
      .getNavChangeEmitter()
      .subscribe((data) => this.selectedNavItem(data));
    this.subscriptions.push(this.subscription);

    const allCompaniesSubscription = this.companyService
      .getAllCompanies(1, 99, '')
      .subscribe((res) => {
        this.companies = res.body;
      });
    this.subscriptions.push(allCompaniesSubscription);

    const companyByUserSubscription = this.companyService
      .getByUser()
      .subscribe((company: any) => {
        if (company.body) {
          this.userCompany = company.body.name;
        }
      });
    this.subscriptions.push(companyByUserSubscription);

    const lastSyncSubscription = this.syncService
      .getLastSync()
      .subscribe((res) => {
        this.lastSync = this.formatDate(res?.body?.lastModifiedDate);
      });
    this.subscriptions.push(lastSyncSubscription);

    const accountEmailSubscription = this.authService
      .getAccount(localStorage.getItem('id'))
      .subscribe((res) => {
        if (res?.userlist?.email.length <= this.maxLength) {
          this.currentEmail = res?.userlist?.email;
        } else {
          this.currentEmail =
            res?.userlist?.email.substr(0, this.maxLength) + '...';
        }
      });
    this.subscriptions.push(accountEmailSubscription);

    const date = this.dataPeriodService.getDate();

    this.minDate = date.start;
    this.maxDate = date.end;
    this.rangeDate = date.range;
  }

  formatDate(initDate) {
    const date = new Date(initDate);

    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = this.padZero(date.getHours());
    const minutes = this.padZero(date.getMinutes());

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  changeMenuState() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  changeSiteLanguage(localeCode: string): void {
    const selectedLanguage = this.languageList
      .find((language) => language.code === localeCode)
      ?.label.toString();
    if (selectedLanguage) {
      this.translate.use(localeCode);
      this.cacheService.setLang(localeCode);
    }
    const currentLanguage = this.translate.currentLang;
    this.setCurrentLanguageImage();
  }

  setCurrentLanguageImage() {
    if (this.translate.currentLang === 'es') {
      this.currentLanguageImage = 'assets/img/flag/spain-flag.png';
    } else if (this.translate.currentLang === 'en') {
      this.currentLanguageImage = 'assets/img/flag/usa-flag.png';
    }
  }

  selectedNavItem(data: any) {
    this.data = data;
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        if (sub && !sub.closed) {
          sub.unsubscribe();
        }
      });
      this.subscriptions = [];
    }
  }

  logout() {
    if (this.authService.isLoggedIn()) {
      this.authService.logout();
    }
  }

  getUserName() {
    if (this.authService.isLoggedIn()) {
      return this.authService.getUserName();
    }
  }

  editUser() {
    this.authService.getAccount(localStorage.getItem('id')).subscribe((res) => {
      this.currentUser = res.userlist;

      this.ngbModalRef = this.modalService.open(PopupEditUserComponent, {
        backdrop: 'static',
        centered: true,
        windowClass: 'modal-holder',
      });
      this.ngbModalRef.componentInstance.currentCompany =
        this.currentUser.idCompany;
      this.ngbModalRef.componentInstance.companies = this.companies['results'];
      this.ngbModalRef.componentInstance.user = this.currentUser;
      this.ngbModalRef.componentInstance.isAccount = true;
      this.ngbModalRef.result.then(
        (result) => {
          this.authService.updateUser(this.currentUser.id, result).subscribe(
            (res) => {
              this.authService
                .getAccount(this.currentUser.id)
                .subscribe((ress) => {
                  localStorage.removeItem('username');
                  localStorage.setItem('username', ress.userlist.name);
                  //window.location.replace('/home')
                });
              this.toastrService.success(
                'El usuario ha sido editado correctamente.'
              );
            },
            (error) => {
              this.toastrService.error(
                'Ha ocurrido un error al editar el usuario.'
              );
            }
          );
        },
        (err) => {
          window.console.log('err');
        }
      );
    });
  }

  setDate(event) {
    this.minDate = event[0];
    this.maxDate = event[1];
  }

  sendDate() {
    this.dataPeriodService.setDate(this.minDate, this.maxDate, [
      this.minDate,
      this.maxDate,
    ]);
  }

  setDatePicker() {}

  showSelectCompanyMenu() {
    if (this.canSelectCompany) {
      this.showSelectCompanyDropdown = !this.showSelectCompanyDropdown;
      setTimeout(() => {
        this.ngSelect?.open();
      }, 100);
    }
  }

  onSelectClose() {
    this.showSelectCompanyDropdown = false;
  }

  async onSelectChange(event) {
    const idCompany = event.value;
    this.isLoadingCompanies = true;
    this.encryptAndCombineData(idCompany.toString()).then((res) => {
      this.authService.getBearerByIdCompany(res).subscribe(
        (data) => {
          if (data) {
            /* console.log(data,"la real data") */
            this.authService.switchAccount(data);
            window.location.reload();
            this.isLoadingCompanies = false;
          }
        },
        (error) => {
          console.log('No admin user found for company.', error);
          this.isLoadingCompanies = false;
        }
      );
    });
  }

  async importKey(): Promise<CryptoKey> {
    const keyData = Uint8Array.from(atob(environment.key), (c) =>
      c.charCodeAt(0)
    );
    return await crypto.subtle.importKey(
      'raw',
      keyData,
      { name: 'AES-GCM' },
      true,
      ['encrypt', 'decrypt']
    );
  }

  async generateValidBase64String(input: Uint8Array): Promise<string> {
    let base64String;
    do {
      base64String = btoa(String.fromCharCode(...input)).replace(/ /g, '');
    } while (base64String.includes(' '));
    return base64String;
  }

  async encryptAndCombineData(data: string): Promise<string> {
    const key = await this.importKey();
    const encoder = new TextEncoder();
    let iv, encrypted, ivString, encryptedString;

    do {
      iv = crypto.getRandomValues(new Uint8Array(12)); // Initialization vector
      encrypted = await crypto.subtle.encrypt(
        {
          name: 'AES-GCM',
          iv: iv,
        },
        key,
        encoder.encode(data)
      );

      ivString = await this.generateValidBase64String(iv);
      encryptedString = await this.generateValidBase64String(
        new Uint8Array(encrypted)
      );
    } while (ivString.includes(' ') || encryptedString.includes(' '));

    return `${ivString}-${encryptedString}`;
  }
}
